import { ICheckoutResponse } from "../../apis/useSubmitCheckout/types";
import { createContextReducer } from "../../common/helpers/createContextReducer";
import { Nullable } from "../../common/types/types";
import { initialState } from "./constants";
import { IPaymentMethod, IPaymentState } from "./types";

const PaymentContextReducer = {
	SET_PAYMENT_METHODS: (state: IPaymentState, paymentMethods: IPaymentMethod[]) => {
		state.paymentMethods = paymentMethods;
	},
	SET_PAYMENT_REFERENCE: (state: IPaymentState, paymentReference: Nullable<string>) => {
		state.paymentReference = paymentReference;
	},
	SET_PAYMENT_DATA: (state: IPaymentState, response: ICheckoutResponse) => {
		state.paymentData = response;
		state.paymentReference = response?.payment_reference;
	},
	CLEAR_PAYMENT_DATA: (state: IPaymentState) => {
		state.paymentMethods = [];
		state.paymentReference = null;
		state.paymentData = null;
	},
};

const {
	AppProvider: PaymentProvider,
	useContextActions: usePaymentActions,
	useContextPartial: usePaymentContext,
} = createContextReducer(initialState, PaymentContextReducer);

export { PaymentProvider, usePaymentActions, usePaymentContext };
